import { Outlet } from "react-router-dom";
import { DomainsSearchUrl, DomainsUrl } from "../../utils/urls";

import { Helmet } from "react-helmet";
import UDomainsTab from "../../components/domains/domains/DomainsTab";
import UDomainsSearchTab from "../../components/domains/search/DomainsSearchTab";

import GlobalIcon from "./../../assets/icons/glob-alt.svg?react";
import SearchIcon from "./../../assets/icons/search.svg?react";
import { Tabs, Typography, TabOptions } from "djuno-design";
import useServiceType from "../../hooks/useServiceType";

export const DomainsPageMenus: TabOptions = [
  {
    label: (
      <div className="flex items-center gap-1">
        <GlobalIcon className="w-3" />
        Domains
      </div>
    ),
    url: DomainsUrl,
    element: <UDomainsTab />,
    testId: "1th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1">
        <SearchIcon className="w-3" />
        Search
      </div>
    ),
    url: DomainsSearchUrl,
    element: <UDomainsSearchTab />,
    testId: "2th-tab",
  },
];

const DomainsPage = () => {
  const { serviceType } = useServiceType(
    import.meta.env.VITE_DOMAINS_SERVICE_TYPE
  );
  return (
    <>
      <Helmet>
        <title>
          {import.meta.env.VITE_APP_NAME} | {serviceType?.ServiceName || ""}
        </title>
        <meta name="description" content="" />
      </Helmet>
      <div className="flex items-center justify-between h-20">
        <div className="px-6 items-center justify-between flex flex-1 transition duration-150">
          <Typography.Title level={5} className="!mb-0">
            {serviceType?.ServiceName}
          </Typography.Title>
        </div>
        {/* <div className="mr-6 w-96"></div> */}
      </div>
      <div className="mx-6">
        <Tabs
          options={DomainsPageMenus.map((o) => ({
            label: o.label,
            url: o.url,
            testId: o.testId,
          }))}
        />
        <div className="py-6">
          <Outlet />
        </div>
      </div>
    </>
  );
};
export default DomainsPage;
